export var SubscriberSourceEnum;
(function (SubscriberSourceEnum) {
    SubscriberSourceEnum["BROADCAST"] = "broadcast";
    SubscriberSourceEnum["SINGLE"] = "single";
    SubscriberSourceEnum["TOPIC"] = "topic";
})(SubscriberSourceEnum || (SubscriberSourceEnum = {}));
export var PreferenceOverrideSourceEnum;
(function (PreferenceOverrideSourceEnum) {
    PreferenceOverrideSourceEnum["SUBSCRIBER"] = "subscriber";
    PreferenceOverrideSourceEnum["TEMPLATE"] = "template";
    PreferenceOverrideSourceEnum["WORKFLOW_OVERRIDE"] = "workflowOverride";
})(PreferenceOverrideSourceEnum || (PreferenceOverrideSourceEnum = {}));
//# sourceMappingURL=subscriber.js.map